/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MoveIssuerRequestBody,
  MoveIssuerRequestBody$Outbound,
  MoveIssuerRequestBody$outboundSchema,
} from "../components/moveissuerrequestbody.js";

export type MoveOrganizationUserSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type MoveOrganizationUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  moveIssuerRequestBody: MoveIssuerRequestBody;
};

/** @internal */
export type MoveOrganizationUserSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const MoveOrganizationUserSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    MoveOrganizationUserSessionIssuerSecurity$Outbound,
    MoveOrganizationUserSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function moveOrganizationUserSessionIssuerSecurityToJSON(
  moveOrganizationUserSessionIssuerSecurity:
    MoveOrganizationUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    MoveOrganizationUserSessionIssuerSecurity$outboundSchema.parse(
      moveOrganizationUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type MoveOrganizationUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  MoveIssuerRequestBody: MoveIssuerRequestBody$Outbound;
};

/** @internal */
export const MoveOrganizationUserSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    MoveOrganizationUserSessionIssuerRequest$Outbound,
    MoveOrganizationUserSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      moveIssuerRequestBody: MoveIssuerRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        moveIssuerRequestBody: "MoveIssuerRequestBody",
      });
    }),
  );

export function moveOrganizationUserSessionIssuerRequestToJSON(
  moveOrganizationUserSessionIssuerRequest:
    MoveOrganizationUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    MoveOrganizationUserSessionIssuerRequest$outboundSchema.parse(
      moveOrganizationUserSessionIssuerRequest,
    ),
  );
}
